const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap'

let injected = false

function injectHead(tag: string, attrs: Record<string, string>) {
  const el = document.createElement(tag)
  for (const k in attrs) el.setAttribute(k, attrs[k])
  document.head.appendChild(el)
  return el
}

export function bootPerf() {
  if (injected || typeof document === 'undefined') return
  injected = true

  // theme-color (uses Hero dark background)
  if (!document.querySelector('meta[name="theme-color"]')) {
    injectHead('meta', { name: 'theme-color', content: '#0A0A0A' })
  }

  // Preconnects (font + shopify CDN for checkout link)
  const preconnects = [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
    'https://cdn.shopify.com',
  ]
  preconnects.forEach((href) => {
    injectHead('link', { rel: 'preconnect', href, crossorigin: '' })
  })

  // DNS prefetch for payment / shopify domains
  ;[
    'https://sistema-iphone-ads.myshopify.com',
    'https://checkout.shopify.com',
  ].forEach((href) => {
    injectHead('link', { rel: 'dns-prefetch', href })
  })

  // Async font stylesheet load (preload + onload swap)
  const preload = injectHead('link', {
    rel: 'preload',
    as: 'style',
    href: FONT_HREF,
  }) as HTMLLinkElement
  preload.onload = function () {
    ;(this as HTMLLinkElement).onload = null
    ;(this as HTMLLinkElement).rel = 'stylesheet'
  }

  // <noscript> fallback so non-JS users still get the font
  const noscript = document.createElement('noscript')
  const fallbackLink = document.createElement('link')
  fallbackLink.rel = 'stylesheet'
  fallbackLink.href = FONT_HREF
  noscript.appendChild(fallbackLink)
  document.head.appendChild(noscript)
}
